class ProductCard extends HTMLElement {
  connectedCallback() {
    this.variantData = JSON.parse(this.querySelector('[type="application/json"]').textContent);
    this.selectedVariantId = this.dataset.variant || this.closest('product-card-wrapper')?.dataset.variant;
    this.selectedVariant = this.variantData.find(i => parseInt(i.id) === parseInt(this.selectedVariantId));
    this.calendarDisplay = (this.dataset.displayType || this.closest('product-card-wrapper')?.dataset.displayType) === 'calendar';
    this.glassOverlay = this.querySelector('[data-glass-overlay]');
    this.badgeOne = this.querySelector('[data-badge-one]');
    this.badgeTwo = this.querySelector('[data-badge-two]');
    if(!this.hasAttribute('data-duration')) {
      this.glassOverlay?.remove();
      return;
    }
    this.calendarIcon = this.querySelector('[data-calendar-icon]');
    this.imageHolder = this.querySelector('.image-block');
    this.enrolled = this.dataset.enrolled;
    this.duration = this.dataset.duration;

    this.imageSwap();

    if(this.calendarDisplay) {
      this.setupCalendarDisplay();
    }
    else {
      this.setupNormalDisplay();
    }
    this.glassOverlay?.remove();
  }

  imageSwap() {
    if(this.selectedVariant?.image?.length && this.imageHolder) {
      const image = this.imageHolder.querySelector(':scope img');
      image.removeAttribute('srcset');
      image.src = this.selectedVariant.image;
    }
  }

  setupCalendarDisplay() {
    if(this.selectedVariant.date.length) {
      const date = new Date(this.selectedVariant.date);
      const month = date.getMonth() + 1;
      this.setAttribute('data-month-filter', month);
      const day = date.getUTCDate();
      const suffix = ['th','st','nd','rd'][((day%100)-10<4&&day%100>10)?0:day%10>3?0:day%10] || 'th';
      const year = date.getUTCFullYear();
      const formatted = `${day}${suffix} ${date.toLocaleString('en-GB', { month: 'long', timeZone: 'UTC' })} ${year}`;

      if(this.badgeOne) {
        this.badgeOne.innerHTML = formatted;
        this.badgeOne.parentNode.style.display = 'block';
        if(this.calendarIcon) this.calendarIcon.style.display = 'flex';
      }

      const listDateDay = this.querySelector('[data-list-date-day]');
      if(listDateDay) listDateDay.textContent = day;

      const listDateMonth = this.querySelector('[data-list-date-month]');
      if(listDateMonth) {
        const shortMonth = date.toLocaleString('en-GB', { month: 'short', timeZone: 'UTC' }).toUpperCase();
        listDateMonth.textContent = `${shortMonth} ${year}`;
      }

      const listDateText = this.querySelector('[data-list-date-text]');
      if(listDateText) listDateText.textContent = formatted;
    }
    this.updateCalendarStatus();
  }

  updateCalendarStatus() {
    const isSoldOut = this.selectedVariant.available === false;
    const isPast = this.selectedVariant.date.length && new Date(this.selectedVariant.date) < new Date();

    this.setAttribute('data-status', isSoldOut ? 'sold-out' : (isPast ? 'past' : 'open'));
    this.setAttribute('data-event-timestamp', this.selectedVariant.date.length ? new Date(this.selectedVariant.date).getTime() : '');

    const setState = (el, show) => {
      if(!el) return;
      el.classList.toggle('hidden', !show);
      el.classList.toggle('inline-flex', show);
    };

    const statusEl = this.querySelector('[data-calendar-status]');
    if(statusEl) {
      setState(statusEl.querySelector('[data-status-sold-out]'), isSoldOut);
      setState(statusEl.querySelector('[data-status-past]'), !isSoldOut && isPast);
      setState(statusEl.querySelector('[data-status-open]'), !isSoldOut && !isPast);
    }

    const ctaEl = this.querySelector('[data-calendar-cta]');
    if(ctaEl) {
      ctaEl.textContent = isPast ? ctaEl.dataset.pastLabel : ctaEl.dataset.openLabel;
    }
  }

  setupNormalDisplay() {
    if(this.calendarIcon) {
      this.calendarIcon.style.display = 'hidden';
    }
    if(this.duration.length) {
      this.badgeOne.innerHTML = this.duration;
      this.badgeOne.parentNode.style.display = 'block';
    }
    else {
      this.badgeOne.parentNode.style.display = 'hidden';
    }
    if(this.enrolled.length) {
      this.badgeTwo.innerHTML = this.enrolled;
      this.badgeTwo.parentNode.style.display = 'block';
    }
    else {
      this.badgeTwo.parentNode.style.display = 'hidden';
    }
  }
  
}

customElements.define('product-card', ProductCard);